import Scrollbar from "../../../../../Public/Frontend/src/scripts/helpers/scrollbarWidth";

export default class Header {
    static init() {
        // scrollbar with detection
        new Scrollbar();

        // init navigation
        new Header(document.querySelector('.header'));
    }

    constructor(element) {
        if (!element) {
            return;
        }
        this.header = element;
        this.navigation = element.querySelector('.navigation');
        this.toggleButton = element.querySelector('.navigation__btn-toggle');
        this.modalSearch = element.querySelector('.navigation__item-search');
        this.toggleButton = element.querySelector('.navigation__btn-toggle');
        this.isNavigationOpen = false;
        this.modalSearch.isOpen = false;
        this.isMobile = window.matchMedia('(max-width: 991px)').matches;

        window.addEventListener('scroll', () => requestAnimationFrame(() => {
            element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');
        }));
        element.classList[window.scrollY < 10 ? 'remove' : 'add']('header--is-scrolled');

        this.setTabIndexes();

        window.addEventListener('click', (e) => {
            const target = e.target;
            const menuLink = target.classList.contains('navigation__link') ? target : false;
            const menuBackButton = target.classList.contains('navigation__btn-back') ? target : false;
            const menuItem = menuLink.parentElement;
            const menuItems = this.navigation.querySelectorAll('.navigation__item');
            const isItemHasDropdown = menuLink && menuItem.classList.contains('navigation__item--has-dropdown') || false;
            const menuSearchButton = target.classList.contains('navigation__link--search') ? target : false;
            const modalSearchCloseButton = target.classList.contains('search-modal__close-button') ? target : false;
            const modalSearchField = this.modalSearch.querySelector('.search-modal__form-field');
            const toggleButton = target.classList.contains('navigation__btn-toggle') ? target : false;
            const header = target.classList.contains('header') ? target : false;
            const isClickInsideSearchModal = this.modalSearch.contains(e.target)

            if (menuSearchButton) {
                this.modalSearch.isOpen = this.isMobile ? true : !this.modalSearch.isOpen;
                this.modalSearch.classList[this.modalSearch.isOpen ? 'add' : 'remove']('is-open');
                modalSearchField[this.modalSearch.isOpen ? 'focus' : 'blur']();
                !this.modalSearch.isOpen ? modalSearchField.value = '' : null;
                this.toggleButton.classList.add('navigation__btn-toggle--is-active');
            }

            if (modalSearchCloseButton) {
                this.modalSearch.querySelector('.search-modal__form').reset();
                this.modalSearch.classList.remove('search-modal--open');
            }

            if (!isClickInsideSearchModal) {
                modalSearchField.blur();
                this.modalSearch.querySelector('.search-modal__form').reset();
                this.modalSearch.classList.remove('is-open');
                this.modalSearch.isOpen = false;
            }

            if (!this.isMobile) return;

            if (menuLink && isItemHasDropdown) {
                e.preventDefault();
                const menuDropdown = menuItem.querySelector('.navigation__dropdown');
                Array.from(menuItems).map((item) => {
                    if (!item.isSameNode(menuItem)) item.classList.remove('navigation__item--active');
                });
                menuItem.classList.add('navigation__item--active');
                this.toggleButton.classList.add('navigation__btn-toggle--is-active');
                this.openMenu(2);

                this.currentDropdown = menuDropdown;
                let menuDropdownRow = menuDropdown.querySelector('.navigation__row');
                let menuDropdownRowScrollHeight = menuDropdownRow ? menuDropdownRow.scrollHeight : 0;
                let menuDropdownRowHeight = menuDropdownRow ? menuDropdownRow.getBoundingClientRect().height : 0;
                menuDropdownRow.addEventListener('scroll', (e) => this.dropdownScrollHandler(e));
                this.currentDropdown.classList[menuDropdownRowScrollHeight > menuDropdownRowHeight ? 'add' : 'remove']('navigation__dropdown--arrow-bottom-visible');
            }

            if (menuBackButton) {
                this.closeMenu(2);
            }

            if (header) {
                e.stopPropagation();
            }

            if (toggleButton) {
                if (toggleButton.classList.contains('navigation__btn-toggle--is-active')) {
                    this.closeAll();
                    Array.from(menuItems).map((item) => {
                        if (!item.isSameNode(menuItem)) item.classList.remove('navigation__item--active');
                    });
                } else {
                    this.openMenu();
                }
            }
        });
    }

    closeMenu(lvl) {
        if (lvl > 1) {
            this.navigation.classList.remove('navigation--lvl-' + lvl);
            if(lvl === 2) {
                document.body.classList.add('menu-open--show-floating-form-on-mobile');
            } else {
                document.body.classList.remove('menu-open--show-floating-form-on-mobile');
            }
        } else {
            this.toggleButton.classList.remove('navigation__btn-toggle--is-active');
            this.navigation.classList.remove('navigation--is-active');
            this.navigation.classList.remove('navigation--lvl-2');
            document.body.classList.remove('menu-open');
            document.body.classList.remove('menu-open--show-floating-form-on-mobile');
            this.isNavigationOpen = false;
            window.dispatchEvent(new CustomEvent('unlock'));
        }

        if (this.currentDropdown) {
            this.currentDropdown.removeEventListener('scroll', (e) => this.dropdownScrollHandler(e));
        }
    }

    openMenu(lvl) {
        if (lvl > 1) {
            this.navigation.classList.add('navigation--lvl-' + lvl);
            document.body.classList.remove('menu-open--show-floating-form-on-mobile');
        } else {
            this.toggleButton.classList.add('navigation__btn-toggle--is-active');
            this.navigation.classList.add('navigation--is-active');
            document.body.classList.add('menu-open');
            document.body.classList.add('menu-open--show-floating-form-on-mobile');
            this.isNavigationOpen = true;
            window.dispatchEvent(new CustomEvent('lock'));
        }
    }

    toggleMenu(lvl) {
        lvl = lvl || 1;
        this.isNavigationOpen ? this.closeMenu() : this.openMenu(lvl);
    }

    closeAll() {
        this.closeMenu(2);
        this.closeMenu(1);
        this.closeMenu();
    }

    dropdownScrollHandler(e) {
        let el = e.target;
        let parent = el.parentElement;
        parent.classList[el.scrollTop > 50 ? 'add' : 'remove']('navigation__dropdown--arrow-top-visible');
        parent.classList[el.scrollHeight - el.getBoundingClientRect().height - el.scrollTop > 50 ? 'add' : 'remove']('navigation__dropdown--arrow-bottom-visible');
    }

    setTabIndexes() {
        let counter = 2;
        let appsMenuItems = this.navigation.querySelectorAll('.navigation > .navigation__menu > .navigation__item');

        Array.prototype.forEach.call(appsMenuItems, (el) => {
            let submenu = el.querySelector('.navigation__dropdown');
            let menuLink = el.querySelector(':scope > .navigation__link');

            if (!menuLink) return;
            menuLink.setAttribute('tabindex', ('' + counter));
            if (submenu) {
                let submenuItems = submenu.querySelectorAll('.navigation__link')
                Array.prototype.forEach.call(submenuItems, (_el) => {
                    counter++;
                    _el.setAttribute('tabindex', ('' + counter));

                    _el.addEventListener("blur", function () {
                        _el.closest('.navigation__item--has-dropdown') ? _el.closest('.navigation__item--has-dropdown').classList.remove('is-visible') : _el.classList.remove('is-visible');
                    });

                    _el.addEventListener("focus", function () {
                        _el.closest('.navigation__item--has-dropdown') ? _el.closest('.navigation__item--has-dropdown').classList.add('is-visible') : _el.classList.add('is-visible');
                    });
                });
            }
            counter++;
        });
    }
}
